import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const applicationDocumentType = {
  state: {
    applicationDocumentTypes: [],
    selectedApplicationDocumentType: {},
    selectedApplicationDocumentTypeOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    applicationDocumentTypes(state) {
      return state.applicationDocumentTypes
    },
    selectedApplicationDocumentType(state) {
      return state.selectedApplicationDocumentType
    },
    selectedApplicationDocumentTypeOriginal(state) {
      return state.selectedApplicationDocumentTypeOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    applicationDocumentTypes(state, payload) {
      state.applicationDocumentTypes = payload
    },
    selectedApplicationDocumentType(state, payload) {
      state.selectedApplicationDocumentType = JSON.parse(JSON.stringify(payload))
    },
    selectedApplicationDocumentTypeOriginal(state, payload) {
      state.selectedApplicationDocumentTypeOriginal = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedApplicationDocumentType(context, payload) {
      context.commit('selectedApplicationDocumentType', payload)
    },
    async loadApplicationDocumentTypes(context, payload) {
      const url = 'ApplicationDocumentType'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('applicationDocumentTypes', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    refreshSelectedApplicationDocumentType(context, payload) {
      if (context.state.selectedApplicationDocumentType && context.state.selectedApplicationDocumentType.Id > 0) {
        context.dispatch('loadSelectedApplicationDocumentType', context.state.selectedApplicationDocumentType.Id)

      }
    },
    async loadSelectedApplicationDocumentType(context, payload) {
      if (context.state.selectedApplicationDocumentType && context.state.selectedApplicationDocumentType.Id != payload) {
        context.commit('selectedApplicationDocumentType', {})
      }
      const url = 'ApplicationDocumentType/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedApplicationDocumentType', res.data)
        context.commit('selectedApplicationDocumentTypeOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    clearLookupCacheAndReloadApplicationDocumentTypes(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
          context.dispatch('loadApplicationDocumentTypes')
      }, )
    },
    async createApplicationDocumentType(context, payload){
      const url = `ApplicationDocumentType`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'application document type created',},{ root: true })
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationDocumentTypes')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchApplicationDocumentType(context, payload){
      var item = context.state.selectedApplicationDocumentType
      if (payload.Id && 
      payload.Id == context.state.selectedApplicationDocumentTypeOriginal.Id)  {
      item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedApplicationDocumentTypeOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(
              original,
              current
            )
        patchPayload.patchDoc = diff

      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `ApplicationDocumentType/${ patchPayload.Id }`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios
          .patch(url, patchPayload.patchDoc)
          context.dispatch('messages/toastMessage',
          {color: 'success', message: 'application document type updated',},{ root: true })
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadApplicationDocumentTypes')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateApplicationDocumentType(context, payload){
      const url = `ApplicationDocumentType/${ payload.Id }`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios
          .put(url, payload)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'application document type updated',},{ root: true })
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationDocumentTypes')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveApplicationDocumentType(context, payload){
      if (payload.Id > 0) {
        return context.dispatch('updateApplicationDocumentType', payload)
      } else {
        return context.dispatch('createApplicationDocumentType', payload)
      }
    },
    async deleteApplicationDocumentType(context, payload){
      const url = `ApplicationDocumentType/${ payload.Id }`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'application document type deleted',},{ root: true })
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationDocumentTypes')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default applicationDocumentType